<template>
    <div>
        <div class="form-title">
            <span id="policyHeader" >Renew Policy</span>
        </div>
        <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="policyRenew">
            <div class="form-row row-cols-md-2 row-cols-1 ach-payment-section">
                <div class="col form-group">
                    <label class="control-label require" for="start_date">Start Date: </label>
                    <div class="input-group">
                        <date-picker placeholder="MM/DD/YYYY" id="new_start_date" name="new_start_date" v-model="new_start_date" :config="optionsDate"></date-picker>
                        <label for="new_start_date" class="fp-calendar input-calender-icon"></label>
                    </div>
                    <div class="field-error">{{new_start_date_error_msg }}</div>
                </div>
                <div class="col form-group">
                    <label class="control-label require" for="new_expiry_date">Expiry Date: </label>
                    <div class="input-group">
                        <date-picker placeholder="MM/DD/YYYY" id="new_expiry_date" name="new_expiry_date" v-model="new_expiry_date" :config="optionsDate"></date-picker>
                        <label for="new_expiry_date" class="fp-calendar input-calender-icon"></label>
                    </div>
                    <div class="field-error">{{new_expiry_date_error_msg }}</div>
                </div>
            </div>
            <div class="field-error">{{common_error_msg }}</div>    
            <div class="btn-groups">
                <button type="submit" id="saveDetailsBtn"  class="btn btn-primary" v-on:click.prevent="saveDetails" >
                    <i class="fp-save"> </i>Save
                </button>

                <button type="submit" id="cancelBtn" class="btn btn-tertiary" v-on:click.prevent="backPolicyView" >
                    <i class="fp-close"> </i>  Cancel
                </button>
            </div>
        </form>    
    </div>        
</template>
<script>
import Vue from "vue";
import {commonMixins} from '../../mixins/commonMixins';
export default {
    name: "InsurancePolicyRenew",
    mixins:[commonMixins],
    data() {
        return {
            start_date:"",
            expiry_date:"",
            new_expiry_date:"",
            new_expiry_date_error_msg:"",
            common_error_msg:"",
            optionsDate: {
                format: 'MM/DD/YYYY',
                useCurrent:false,
            },
            new_start_date:"",
            new_start_date_error_msg:"",
        }
    },
    mounted: function(){
        var self = this;
        self.start_date = this.$parent.start_date;
        self.expiry_date = this.$parent.expiry_date;
        self.new_expiry_date = this.$parent.expiry_date;
        self.new_start_date = this.$parent.start_date;
        
    },
    methods: {
        saveDetails() {
            var self = this;
            var error = false;
            self.new_expiry_date_error_msg = "";
            self.common_error_msg = "";
            self.new_start_date_error_msg = "";

            const strDate = self.start_date; // input date in m/d/Y format
            const strDtArr = strDate.split("/");
            const startDate = strDtArr[2] + "-" + strDtArr[0].padStart(2, '0') + "-" + strDtArr[1].padStart(2, '0'); 
            var actStrDate = startDate;

            const nwDate = self.new_start_date; // input date in m/d/Y format
            const newDtArr = nwDate.split("/");
            const newDate = newDtArr[2] + "-" + newDtArr[0].padStart(2, '0') + "-" + newDtArr[1].padStart(2, '0'); 
            var actNewDate = newDate;

            if (!self.new_start_date || self.new_start_date == null || self.new_start_date == "") {
                self.new_start_date_error_msg = "Start Date Required.";
                error = true;
            } else {
                if (Date.parse(actNewDate) < Date.parse(actStrDate)) {
                    self.new_start_date_error_msg = "Start Date should be greater than Old Start Date.";
                    error = true;
                }
            }

            const expDate = self.expiry_date; // input date in m/d/Y format
            const expDtArr = expDate.split("/");
            const expiryDate = expDtArr[2] + "-" + expDtArr[0].padStart(2, '0') + "-" + expDtArr[1].padStart(2, '0'); 
            var actExpDate = expiryDate;

            const nwExpDate = self.new_expiry_date; // input date in m/d/Y format
            const newExpArr = nwExpDate.split("/");
            const newExpDate = newExpArr[2] + "-" + newExpArr[0].padStart(2, '0') + "-" + newExpArr[1].padStart(2, '0'); 
            var actNewExpDate = newExpDate;

            if (!self.new_expiry_date || self.new_expiry_date == null || self.new_expiry_date == "") {
                self.new_expiry_date_error_msg = "Expiry Date Required.";
                error = true;
            }else{
                if (Date.parse(actNewExpDate) < Date.parse(actExpDate)) {
                    self.new_expiry_date_error_msg = "Expiry Date should be greater than Old Expiry Date.";
                    error = true;
                }
            }

            if (self.new_start_date != "" && self.new_start_date != null && self.new_expiry_date != "" && self.new_expiry_date != null){

                if (new Date(self.new_expiry_date) < new Date(self.new_start_date)) {
                    self.common_error_msg = "Expiry Date should not be earlier than Start Date.";
                    error = true;
                }
            }
            if (!error) {
                var path = window.location.pathname;
                var segments = path.split("/");
                
                if (segments[3] != undefined && segments[3] != null) {

                    $("#saveDetailsBtn").val("Saving ...");
                    $("#saveDetailsBtn").prop("disabled", true);
                    $("#cancelBtn").prop("disabled",true);

                    self.$parent.loading = true;

                    $.ajax({
                        url: process.env.ROOT_API + "/insurancepolicy/renew",
                        type: "POST",
                        data: {id:segments[3],expiry_date:self.new_expiry_date,start_date:self.new_start_date},
                        headers: this.ajxHeaders,
                        dataType: "json",
                        success: function (data) {

                            self.$parent.loading = false;
                            $("#saveDetailsBtn").val("Save");
                            $("#saveDetailsBtn").prop("disabled", false);
                            $("#cancelBtn").prop("disabled",false);
                            if (data.status == "success") {
                                self.$parent.renewInsurancePolicy = false;
                                self.$parent.loadInsurancePolicy();
                                self.$parent.refreshActivityLog();
                                
                            } else {
                                if (data.content.length > 0) {
                                    var err = "";
                                    for (var i = 0; i < data.content.length; i++) {
                                        err += data.content[i] + "<br>";
                                        self.common_error_msg += data.content[i] + "\n";
                                    }
                                    // $("#errorMsg").html(err);
                                    // $(".alert-warning").toggleClass("show");
                                    setTimeout(function () {
                                        // $(".alert-warning").removeClass("show");
                                        // $(".alert-warning").addClass("hide");
                                        self.common_error_msg = "";
                                    }, 10000);
                                }
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.$parent.loading = false;
                            $("#saveDetailsBtn").val("Save");
                            $("#saveDetailsBtn").prop("disabled", false);
                            $("#cancelBtn").prop("disabled",false);
                            self.generateStatusCodeMessage(jqXHR,true,'insurance-policy-renew')
                        }
                    });
                }
            }
        },
        backPolicyView() {
            var self = this;
            self.new_expiry_date_error_msg = "";
            self.$parent.renewInsurancePolicy = false;
        }
    }    
}
</script>


// WEBPACK FOOTER //
// src/components/insurance/InsurancePolicyRenew.vue